@if (loaded) {
  <ion-content class="blue-bg">
    <!-- added title -->
    <ion-row class="title-head">
      <ion-col size="10">
        <p class="status-title">{{ "syndicate-setting.pageTitle" | translate }}</p>
      </ion-col>
      <ion-col size="2">
        <ion-icon name="close-circle" class="close-icon" (click)="goBack()"></ion-icon>
      </ion-col>
    </ion-row>
    <div class="page-background-blue">
      <ion-grid class="ion-no-padding syndicate-details-wrapper">
        <ion-row class="ion-no-padding ion-text-center">
          <ion-col
            style="background-image: url({{ syndicate?.syndicate_image_url ? syndicate?.syndicate_image_url : syndicate?.ps_image_url }});"
            class="syndicate-image bg-placement">
          </ion-col>
        </ion-row>
        <ion-row>
          <h1 class="sub-header">{{ "syndicate-setting.Syndicate info" | translate }}</h1>
        </ion-row>
        <ion-card class="cards-for-setting">
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Name" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details">{{ syndicate?.vm?.syndicateName }}</h1>
            </ion-col>
          </ion-row>
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Total lines" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details">{{ syndicate?.vm?.totalLinesPerWeek }}</h1>
            </ion-col>
          </ion-row>
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Created" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details">{{ (syndicate?.vm?.createdOn?.toDate() | date: "dd") + ' ' +('dynamic_value.' +
                (syndicate?.vm?.createdOn?.toDate() | date: "MMM") | translate)
                + ' ' + (syndicate?.vm?.createdOn?.toDate() | date:
              "yyyy") }}</h1>
            </ion-col>
          </ion-row>
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Lastdraw" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details">{{ (syndicate?.vm?.nextDrawDate?.toDate() | date: "dd") + ' ' +('dynamic_value.' +
                (syndicate?.vm?.nextDrawDate?.toDate() | date: "MMM") | translate)
                + ' ' + (syndicate?.vm?.nextDrawDate?.toDate() | date:
              "yyyy") }}</h1>
            </ion-col>
          </ion-row>
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Type" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details">{{ ('dynamic_value.'+ syndicate?.vm?.syndicateType | translate)?.indexOf('dynamic_value') &gt; -1 ? (syndicate?.vm?.syndicateType) : ('dynamic_value.'+ syndicate?.vm?.syndicateType | translate)}}</h1>
            </ion-col>
          </ion-row>
          <ion-row class="details-row">
            <ion-col class="ion-no-padding">
              <h1 class="details-heading">{{ "syndicate-setting.Status" | translate }}</h1>
            </ion-col>
            <ion-col class="ion-no-padding">
              <h1 class="user-details status-data">
                {{ ('dynamic_value.'+ syndicate?.vm?.activeStatus | translate)?.indexOf('dynamic_value') &gt; -1 ? (syndicate?.vm?.activeStatus) : ('dynamic_value.'+ syndicate?.vm?.activeStatus | translate) }}<br>@if (syndicate?.vm?.activeStatus?.toLowerCase() === 'paused') {
                <span
                  >
                  {{ "syndicate-setting.until" | translate }}
                  {{
                  syndicate?.vm?.nextResumeDate ? (syndicate?.vm?.nextResumeDate?.toDate() | date: "dd") + ' '
                  +('dynamic_value.' +
                  (syndicate?.vm?.nextResumeDate?.toDate() | date: "MMM") | translate)
                  + ' ' + (syndicate?.vm?.nextResumeDate?.toDate() | date:
                  "yyyy") : null
                  }}
                </span>
              }
              @if (
                syndicate?.vm?.syndicateStatus?.toLowerCase() !== 'deactive' &&
                syndicate?.vm?.syndicateStatus?.toLowerCase() !== 'ended'
                ) {
                <div>
                  <!-- <ion-icon (click)="openSyndicateStatus(syndicate)" class="arrow-icon" name="chevron-forward-outline">
                </ion-icon> -->
              </div>
            }
          </h1>
        </ion-col>
      </ion-row>
      <!-- manage syndicate -->
      <!-- <ion-row
      class="details-row"
          *ngIf="
            syndicate &&
            syndicate?.active_status &&
            syndicate?.active_status?.toLowerCase() !== 'ended' &&
            syndicate?.active_status?.toLowerCase() !== '  '
          ">
      <ion-col class="ion-no-padding">
        <h1 class="details-heading">{{ "syndicate-setting.manageSyndicate" | translate }}</h1>
      </ion-col>
      <ion-col class="ion-no-padding">
        <h1 class="link-text-blue user-details" (click)="openSyndicateStatus(syndicate)">
          {{ "syndicate-setting.syndicateview" | translate }}
        </h1>
      </ion-col>
    </ion-row> -->
    <!-- updated code -->
    @if (
      syndicate &&
      syndicate?.active_status &&
      syndicate?.active_status?.toLowerCase() !== 'ended' &&
      syndicate?.active_status?.toLowerCase() !== 'oneoff'
      ) {
      <ion-row class="details-row splitter-line-bottom">
        <ion-col class="ion-no-padding">
          <h1 class="details-heading">{{ "syndicate-setting.manageSyndicate" | translate }}</h1>
        </ion-col>
        <ion-col class="ion-no-padding">
          <h1 class="link-text-blue user-details" (click)="openSyndicateStatus(syndicate)">{{ "syndicate-setting.view" | translate }}</h1>
        </ion-col>
      </ion-row>
    }
    <!-- Win more -->
    @if (syndicate?.win_more_end === false) {
      <ion-row class="details-row splitter-line-bottom">
        <ion-col class="ion-no-padding">
          <h1 class="details-heading">{{ "syndicate-setting.win_more_promise" | translate }}</h1>
        </ion-col>
        <ion-col class="ion-no-padding">
          <h1 class="link-text-blue user-details" (click)="showPromisePopup()">
            {{ "syndicate-setting.view" | translate }}
          </h1>
        </ion-col>
      </ion-row>
    }
    <!-- updated code -->
    <ion-row class="details-row">
      <ion-col class="ion-no-padding">
        <h1 class="details-heading">{{ "syndicate-setting.Share" | translate }}</h1>
      </ion-col>
      @if (!dotAnimation) {
        <ion-col class="ion-no-padding">
          @if (!syndicate?.syndicate_size) {
            <h1 class="link-text-blue user-details"
              (click)="viewSyndicateMemberCount(syndicate)">
              {{ "syndicate-setting.shareview" | translate }}
            </h1>
          } @else {
            <h1 class="user-details">
              {{ syndicate?.syndicate_size == 0 ? "-" : syndicate?.syndicate_size }}
            </h1>
          }
        </ion-col>
      }
      @if (dotAnimation) {
        <app-dot-flash-animation></app-dot-flash-animation>
      }
    </ion-row>
    <ion-row class="details-row">
      <ion-col class="ion-no-padding" size="8 ">
        <h1 class="details-heading">{{ "syndicate-setting.syndicatesummary" | translate }}</h1>
      </ion-col>
      <ion-col class="ion-no-padding" size="4 ">
        <h1 class="link-text-blue user-details"
          (click)="viewSyndicateSummary(syndicate?.syndicate_type, syndicate?.tc , syndicate?.vm?.syndicateName)">
          {{ "syndicate-setting.syndicateview" | translate }}
        </h1>
      </ion-col>
    </ion-row>
  </ion-card>
  <!-- playing -->
  <ion-row>
    <h1 class="sub-header heading-playingin-text">{{ "syndicate-setting.Playing" | translate }}</h1>
  </ion-row>
  <ion-card class="cards-for-setting">
    @for (playItem of syndicate?.products; track playItem) {
      <ion-row class="jackpot-container">
        <ion-col size="1.8" class="ion-no-padding jackpot-image">
          <img class="jackpot-logo" src="{{ playItem?.image_url }} " alt="jackpotImage" />
        </ion-col>
        <ion-col size="6.2" class="product-lines ion-no-padding">
          <h3 class="jackpot-name">{{ playItem?.product_name }}</h3>
          <p class="lines-available">
            {{ typeCheck(playItem?.draw_day) === "string" ? ('dynamic_value.'+(playItem?.draw_day) | translate) :
            ('dynamic_value.'+(playItem?.draw_day?.join(",")) | translate) }}
          </p>
        </ion-col>
        <ion-col size="4" class="ion-no-padding">
          <h1 class="jackpot-count">x{{ playItem?.total_lines }}</h1>
        </ion-col>
      </ion-row>
    }
    <!-- <ion-row class="leave-syndicate-wrapper ">
    <h1 class="warning-text txt-leave-syndicate " (click)="leaveSyndicateConfirmation() ">Leave syndicate</h1>
  </ion-row> -->
</ion-card>
</ion-grid>
</div>
</ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}

